import axios from 'axios'
import 'dotenv/config'

let api = null
let apiAWS = null
const baseURLApi = process.env.MODE_APP === 'prod' ? process.env.API_BASE_URL_PROD : process.env.API_BASE_URL_DEV

export function createApi() {
  api = axios.create({
    baseURL: baseURLApi,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    },
  })

  api.interceptors.request.use(
    config => {
      const token = localStorage.getItem('token') || ''
      if (token) {
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    error => Promise.reject(error),
  )

  api.interceptors.response.use(
    response => response,
    async error => {
      const { status } = error.response
      if (status === 401) {
        try {
          const { data } = await api.post('/auth/refreshToken', {
            refreshToken: localStorage.getItem('refreshToken'),
          })

          localStorage.setItem('accessToken', data.accessToken)
          localStorage.setItem('refreshToken', data.refreshToken)
          api.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('accessToken')}`
          return api(error.config)
        } catch (e) {
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
          window.location.href = '/'
        }
      } else if (status === 403) {
        console.log('STATUS: 403')
      }
      return Promise.reject(error)
    },
  )

  return api
}

export function useApi() {
  if (!api) {
    createApi()
  }
  return api
}
const baseURLAWS = process.env.MODE_APP === 'prod' ? process.env.AWS_BASE_URL_PROD : process.env.AWS_BASE_URL_DEV
export function createApiAWS() {
  apiAWS = axios.create({
    baseURL: baseURLAWS,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  return apiAWS
}

export function useApiAWS() {
  if (!apiAWS) {
    createApiAWS()
  }
  return apiAWS
}
